<forge-card class="chart" no-padding>
    <forge-toolbar>
        <div slot="start" fxLayout="column">
            <h2 class="forge-typography--heading4">{{ChartTitle}}</h2>
            <truncate-text class="forge-typography--subheading1" *ngIf="isLoaded" [allowHtml]="true" fxFlex="100"
                           [mainText]="ChartSubtitle">
            </truncate-text>
        </div>

        <forge-icon-button slot="end" class="chart-settings" (click)="openSettings()" tabindex="0" aria-haspopup="true"
                           telemetry="Chart settings" aria-label="chart settings">
            <forge-tooltip>Chart settings</forge-tooltip>
            <forge-icon name="settings"></forge-icon>
        </forge-icon-button>
    </forge-toolbar>

    <div class="metadata-padding">
        <div *ngIf="isLoaded">
            <chartjs-container *ngIf="showChart" [config]="chartConfig">
            </chartjs-container>

            <div *ngIf="!chartHasData">
                Not enough data to display graph
            </div>

            <div *ngIf="errorMessage" class="error-red">
                {{errorMessage}}
            </div>
        </div>

        <busy-indicator *ngIf="!isLoaded" [chart]="true"></busy-indicator>

        <div *ngIf="showChart" fxLayout="row" fxLayoutAlign="end center">
            <command-bar telemetry="Menu-GenericChart" [commands]="commands"></command-bar>
        </div>
    </div>
</forge-card>
